import { Link } from "react-router-dom";
import Seo, { orgSchema, breadcrumbSchema } from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { FadeUp, ParallaxImage } from "@/components/Reveal";
import { PROJECTS } from "@/data/content";

export default function Projects() {
    return (
        <>
            <Seo
                title="Projects — Design Studies & Works | Dagaz Development"
                description="Selected custom home, reconstruction and commercial studies by Dagaz Development — timber, stone and glass across the Pacific Northwest, Utah, Illinois and British Columbia."
                path="/projects"
                jsonLd={[orgSchema, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Projects", path: "/projects" }])]}
            />
            <PageHeader
                eyebrow="Projects — European Portfolio"
                titleLines={["Work that proves", "the philosophy."]}
                answer="Delivered work from Dagaz Development's European portfolio — custom homes and reconstructions in Slovakia and Germany, composed in timber, stone and glass — alongside concept studies now in development for the United States and Canada."
                crumbs={[{ name: "Projects" }]}
            />
            <section className="px-6 md:px-12 lg:px-16 pb-28 md:pb-40 bg-chalk space-y-24 md:space-y-36" data-testid="projects-list">
                {PROJECTS.map((p, i) => (
                    <FadeUp key={p.slug}>
                        <article className={`grid lg:grid-cols-12 gap-8 items-end ${i % 2 === 1 ? "" : ""}`}>
                            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2 lg:col-start-6" : ""}`}>
                                <Link to={`/projects/${p.slug}`} data-testid={`projects-row-image-${p.slug}`} className="group block">
                                    <ParallaxImage
                                        src={p.image}
                                        alt={`${p.name} — ${p.type}, ${p.location}`}
                                        className="h-[340px] md:h-[480px]"
                                        speed={7}
                                    />
                                </Link>
                            </div>
                            <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1 lg:col-start-1" : ""}`}>
                                <p className="font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-gold">{p.status} — {p.year}</p>
                                <Link to={`/projects/${p.slug}`} data-testid={`projects-row-${p.slug}`} className="group inline-block mt-4">
                                    <h2 className="font-serif font-light text-4xl md:text-5xl text-graphite group-hover:italic transition-all duration-500">{p.name}</h2>
                                </Link>
                                <p className="mt-3 font-sans text-[11px] font-medium tracking-[0.2em] uppercase text-slate">
                                    {p.type} — {p.location}
                                </p>
                                <p className="mt-6 font-sans text-sm md:text-base leading-relaxed text-graphite/75 max-w-md">
                                    {p.description}
                                </p>
                                <p className="mt-6 font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-slate border-t border-graphite/15 pt-4">
                                    {p.materials}
                                </p>
                            </div>
                        </article>
                    </FadeUp>
                ))}
            </section>
        </>
    );
}
